// 选择模式
export enum ComposedDateMode {
  // 相对时间
  Relative = 1,
  // 绝对时间
  Absolute = 2,
}
